import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { User360ReportLayer } from "../components/Report/User360ReportLayer";

export const User360ReportPage = () => (
  <MasterLayout>
    <User360ReportLayer />
  </MasterLayout>
);
